<template>
  <div class="project-tasks-section">
    <div class="project-tasks-section__main">
      <TasksKanban
        :settings="tasksKanbanSettings"
        :queue-id="queueId"
        :project-id="projectId"
        :namespace-id="namespaceId"
        :namespaceName="props.namespaceName"
        @toggle-submenu="emit('toggle-submenu', $event)"
        @open-options="openEditQueueModal"
      />
    </div>
  </div>
  <EditQueueModal :queue="editQueue" @close="closeEditQueueModal" />
</template>

<script lang="ts" setup>
import { TasksKanban, TasksKanbanExternalSettings } from "@/components";
import EditQueueModal from "@/components/edit-queue-modal/edit-queue-modal.vue";
import { useSidebarTree } from "@/components/sidebar/composables";
import { QueueTasksModel } from "@/components/sidebar/models";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";

const emit = defineEmits<{
  /**Событие для раскрытия сайтбара */
  (e: "toggle-submenu", queueId: string): void;
  (e: "open-options", queueId: string): void;
}>();

const props = defineProps({
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  namespaceName: {
    type: String,
    required: true,
  },
});
/**Id редактируемой очереди */
const editQueue = ref<QueueTasksModel>();
/**
 * * Закрыть окно редактирования очереди
 */
const closeEditQueueModal = () => (editQueue.value = undefined);
const tasksKanbanSettings: TasksKanbanExternalSettings = {
  showNestedTasks: true,
};
const { sidebarItems } = useSidebarTree();
function onOpenOptionsQueue(queueId) {
  // emit("open-options", queueId);
  openEditQueueModal();
}
const queueCurrent = ref(new QueueTasksModel());
watch(
  () => props.namespaceName,
  async () => {
    // isAdminNamespace.value = await adapter.checkNamespaceAdmin(props.namespaceId);
    queueCurrent.value = new QueueTasksModel({
      Id: route.params.queueId.toString(),
      NamespaceId: route.params.namespaceId.toString(),
      Name: props.namespaceName,
    });
  },
);
const route = useRoute();
/**
 * * Открытие окна для редактирования очереди
 */
function openEditQueueModal() {
  const res = localStorage.getItem("queueModel");
  let queue;
  if (res) {
    queue = JSON.parse(res);
  }
  queueCurrent.value = new QueueTasksModel({
    Id: route.params.queueId.toString(),
    NamespaceId: route.params.namespaceId.toString(),
    Name: queue?.Name ? queue.Name : "undefined",
  });
  editQueue.value = queueCurrent.value;

  // editQueue.value = props.menuItem;
}
</script>

<style lang="scss" scoped />
